/* eslint-disable no-invalid-this */
// eslint-disable-next-line func-style
export function isColorVariable(k, factory) {
  const v = factory[k]
  const isSrtingVar = (v2) => this.call('isString', v2) && v2.startsWith('--')
  if (this.call('isString', v)) {
    return isSrtingVar(v)
  }
  if (this.call('isArray', v)) {
    return v.some(isSrtingVar)
  }
  if (this.call('isObject', v)) {
    return Object.values(v).some(isSrtingVar)
  }
  return false
}
